import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import DayBookTable from './DayBokTable';
import HeaderSection from '../../../../components/common/Header/HeaderSection';

function DayBook() {
  const colors = useColors();


  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Day Book" 
        breadcrumb={["Dashboard", "Accounts", "Day Book"]} 
      />

      <HStack align="start" w="full"  gap="0" mt={4} p={6}>
        <DayBookTable colors={colors} />

      </HStack>
    </div>
  );
}

export default DayBook;
